import { connect } from "react-redux";
import RcStatusRemark from "./RcStatusRemark";
import { bindActionCreators } from "redux";
import {rcCaseByIdRequest} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    rcCaseByIdResponse : state.Dealer.rcCaseByIdResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        rcCaseByIdRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RcStatusRemark);